export const StarFilled = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: "currentColor" }}
    {...props}
  >
    <path
      d="M11.9404 7.86523L12.0137 8.03809L12.2012 8.05469L17.1475 8.48535L13.3877 11.7061L13.2432 11.8301L13.2871 12.0156L14.4268 16.8496L10.1611 14.2842L10 14.1875L9.83887 14.2842L5.57129 16.8496L6.71289 12.0156L6.75586 11.8301L6.61133 11.7061L2.85059 8.48535L7.79883 8.05469L7.98535 8.03809L8.05957 7.86523L9.99902 3.29883L11.9404 7.86523Z"
      stroke="currentColor"
      strokeWidth="0.625"
    />
  </svg>
);
